import clsx from "clsx";
import React, { FC } from "react";
import { GenericComponentTypes } from "@/types/common/library";
import { IconName } from "@fortawesome/fontawesome-common-types";

export enum ICON_SIZES {
  XXS = "2xs",
  XS = "xs",
  SM = "sm",
  BASE = "",
  LG = "lg",
  XL = "xl",
  XXL = "2xl",
}

enum ICON_ROTATE {
  BASE = "",
  DEG_90 = "rotate-90",
  DEG_180 = "rotate-180",
  DEG_270 = "rotate-270",
}

export enum ICON_FLIP {
  BASE = "",
  HORIZONTAL = "flip-horizontal",
  VERTICAL = "flip-vertical",
  BOTH = "flip-both",
}

export enum ICON_ANIMATE {
  BASE = "",
  BEAT = "beat",
  FADE = "fade",
  BEAT_FADE = "beat-fade",
  FADE_BEAT = "fade-beat",
  BOUNCE = "bounce",
  FLIP = "flip",
  SHAKE = "shake",
  SPIN = "spin",
}

export enum ICON_TYPE {
  CUSTOM = "fa-kit",
  LIGHT = "fa-light",
  REGULAR = "fa-regular",
  SOLID = "fa-solid",
  DUOTONE = "fa-duotone",
  BRAND = "fa-brands",
}

export type IconNameExtended =
  | `${IconName}`
  | `lula-${string}`
  | `custom-${string}`;

export type IconProps = {
  icon: IconNameExtended;
  type?: ICON_TYPE;
  title?: string;
  size?: ICON_SIZES | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  rotate?: ICON_ROTATE | number;
  flip?: ICON_FLIP;
  animate?: ICON_ANIMATE;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
} & GenericComponentTypes;

const Icon: FC<IconProps> = ({
  icon,
  type,
  className,
  size,
  rotate,
  flip,
  animate,
  onClick,
  ...other
}) => {
  let style = {};

  const safeIcon =
    typeof icon === "string" && icon.length > 0 ? icon : ("question" as string);
  let typeClass = type || ICON_TYPE.LIGHT;
  let sizeClass = size || "";
  let rotateClass = rotate || "";

  if (
    typeof safeIcon === "string" &&
    (safeIcon.startsWith("custom") || safeIcon.startsWith("lula"))
  ) {
    typeClass = ICON_TYPE.CUSTOM;
  }

  if (Number.isInteger(sizeClass)) {
    sizeClass = sizeClass + "x";
  }

  if (typeof rotate === "number") {
    rotateClass = "rotate-by";
    style = {
      ...style,
      ["--fa-rotate-angle"]: `${rotate}deg`,
    };
  }

  return (
    <i
      key={`icon-${safeIcon}`}
      onClick={onClick}
      suppressHydrationWarning
      aria-hidden="true"
      className={clsx(
        typeClass,
        `fa-${safeIcon}`,
        {
          [`fa-${sizeClass}`]: !!sizeClass,
          [`fa-${rotateClass}`]: !!rotateClass,
          [`fa-${flip}`]: !!flip,
          [`fa-${animate}`]: !!animate,
        },
        className,
      )}
      style={style}
      {...other}
    ></i>
  );
};
export { Icon };
export default Icon;
